/* © NXAPP Limited */
import { cn } from '@/lib/utils'

export default function Spinner({ className }: { className?: string }) {
  return (
    <div className={cn('inline-block w-5 h-5 border-2 border-gray-300 border-t-brand-600 rounded-full animate-spin', className)} />
  )
}
